const RequestCode: React.FunctionComponent<{}> = () => {
    return (<>Request Code</>)
}
export default RequestCode